(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('homey-hero-slider')) {
    customElements.define('homey-hero-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.delay = Math.max(3500, Number(this.dataset.delay) || 6000);
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.timer = null;
        this.pointerStart = null;
        this.style.setProperty('--homey-delay', `${this.delay}ms`);

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot), true)));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('pointerdown', (event) => { this.pointerStart = event.clientX; });
        this.addEventListener('pointerup', (event) => {
          if (this.pointerStart === null) return;
          const distance = event.clientX - this.pointerStart;
          this.pointerStart = null;
          if (Math.abs(distance) < 45) return;
          this.go(this.index + (distance > 0 ? -1 : 1), true);
        });
        this.addEventListener('pointercancel', () => { this.pointerStart = null; });
        document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());

        this.start();
      }

      disconnectedCallback() { this.stop(); }

      go(nextIndex, restart = false) {
        if (!this.slides.length) return;
        const normalized = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === normalized;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, index) => {
          const active = index === normalized;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.index = normalized;
        if (restart) this.start(true);
      }

      stop() {
        window.clearTimeout(this.timer);
        this.timer = null;
        this.classList.remove('is-playing');
      }

      start(force = false) {
        this.stop();
        if (!this.autoplay || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!force && this.matches(':hover')) return;
        void this.offsetWidth;
        this.classList.add('is-playing');
        this.timer = window.setTimeout(() => this.go(this.index + 1, true), this.delay);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
